import React from 'react'
import Form from "../../Forms/Containers/FormCreator";

import { victimObject } from './VictimObject'


class AddVictimCompionent extends React.Component {
  state = {
    object: []
  }
  async componentDidMount() {
    const object = await victimObject(this.props)
    console.log(object)
    this.setState({ object })
  }
  render() {
    return (
      <div>
        <div className="modal-add-murdered">Adicionar víctima</div>
        <div style={{ overflow: 'auto' }}>
          {
            !!this.state.object.length &&
            <Form
              onChange={this.props.onChange}
              onSubmit={this.props.onSubmit}
              objectCreator={this.state.object}
              values={this.props.values}
            />
          }
        </div>
      </div>
    )
  }
}

export default AddVictimCompionent